import React from 'react'

import { Button } from '../../module'
import styles from './_background-overlay.module.scss'

type BackgroundOverlayProps = {
  /** Close the background overlay */
  close: () => void
  /** Optionally override the styles if needed */
  style?: React.CSSProperties
  /** Boolean used to determine when to start fadeIn / fadeOut animations */
  isTransitioning: boolean
}

const BackgroundOverlay = ({
  close,
  style = {},
  isTransitioning,
}: BackgroundOverlayProps): React.JSX.Element => {
  const closeCallout = () => {
    close()
  }

  return (
    <Button as='unstyled' onClick={closeCallout}>
      <div
        className={`${styles.overlay} animated ${isTransitioning ? 'fadeOut' : 'fadeIn'}`}
        style={style}
      />
    </Button>
  )
}

export default BackgroundOverlay
